/**
 * @see {@link https://sweetgreen.atlassian.net/wiki/spaces/TD/pages/4528570450/Feature+Flags#%F0%9F%93%9B-Naming-Conventions Naming Conventions}
 */
export const featureFlagDefaults = {
  'OPS-challenges-enabled': false,
  'OPS-kustomer-enabled': false,
  'OPS-enable-maintenance-mode': false,
  'OPS-XP-2978-checkout-validation': false,
  'OPS-contentful-enabled': false,
  'OPS-ca-data-request': false,
  'permanent-scan-to-pay-enabled': false,
  'permanent-order-help-shortcode-enabled': false,
  'permanent-in-app-review-enabled': false,
  'permanent-apple-wallet-enabled': false,
  'permanent-app-tracking-transparency-enabled': false,
  'permanent-refer-friend-enabled': false,
  'pickup-location-selector': true,
  'OPS-sweetpass-enabled': false,
  'product-deep-linking-enabled': false,
  'OPS-customer-decoupling-login-enabled': false,
  'OPS-OP-615-order-validation-cc-and-pickup': false,
  'XP-3094-short-single-delivery-location-pin': false,
  'XP-3179-short-maps-auto-bound-enabled': false,
  'XP-3179-short-maps-offset-enabled': false,
  'XP-3189-short-disable-search-controls-while-fetching-locations': false,
  'XP-3188-short-challenges-cache-enabled': false,
  'XP-3203-short-delivery-in-flight-modal-enabled': false,
  'MNU-656-deeplink-continue-button-enabled': false,
  'XP-3156-short-locations-results-redesign': false,
  'XP-3212-short-in-store-order-feedback-enabled': false,
};
